/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerDeadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABoElEQVR4nN2VvU7DMBDHIwYWkFiAjbliRUIsfJShEoN9dxmcu0hdoDwCHwsijPAUIMYKqX2TLu0rMBUQjEhQ5CQVhcRtk05g6RQlvvv//L84sef9q4HIa0D8oEnegGRQJJIabgGYilNcozwVFYZM8LPVygDsymcXlyRQmhnAsC0a5Uz7UgPiLiJXNXLDKQTBLoBsaZKe8oMNIl7XyB9A/JrjIO2lLzV7H0XRXNq6qgug/GBzNNdChnNuAElvWGCv1smYfndduU6AonBvdFUAwb4LYN253Lod2J7Hosk7QAyPnVsTuZGIZnOdgJz4BJJ7ReG2MWbJBiLv2GfpXG7dVACN/A4g4DmGwpDinLIAhXxi5w6MWQHkO038YgNIbpUKl5M6Pi0NAJIL36+vauJO9tfAnRhMfJnjvF/kHQwmfLVtu/NqtfqCq5WlARr5fKzoTACUtq0zxswD8Y1GfhyZP5oZoNIPEkiuf7m6ynVQ9AwwxizGdT9XHo1pEbeKALysc7d4nAimYg+LkoBo+iMTpWn/5xN2T/97YcHhVOJ/dnwBFwJwRk62+8EAAAAASUVORK5CYII=)
 */
export const StickerDeadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 2h12a4 4 0 0 1 4 4v7.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v2.5a.5.5 0 0 1-.5.5H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm-.3 3.3a1 1 0 0 0-1.4 1.4l.79.8-.8.8a1 1 0 0 0 1.42 1.4l.79-.79.8.8a1 1 0 0 0 1.4-1.42l-.79-.79.8-.8a1 1 0 0 0-1.42-1.4l-.79.79-.8-.8Zm9.6 0a1 1 0 0 1 1.4 0l.8.79.8-.8a1 1 0 1 1 1.4 1.42l-.79.79.8.8a1 1 0 0 1-1.42 1.4l-.79-.79-.8.8a1 1 0 0 1-1.4-1.42l.79-.79-.8-.8a1 1 0 0 1 0-1.4Zm-6.21 8.26a1 1 0 0 1-1.66-1.12 5.5 5.5 0 0 1 9.14 0 1 1 0 0 1-1.66 1.12 3.5 3.5 0 0 0-5.82 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 16c.03 0 .05.03.04.06a3 3 0 0 1-.58.82l-4.24 4.24a3 3 0 0 1-.82.58.04.04 0 0 1-.06-.04V19a3 3 0 0 1 3-3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
